import store from "@frameworks/web/redux/store";
import { UPI_LIST_DATA, UPI_LIST_ERROR_DATA, UPI_LIST_HIDE_ERROR_DATA, UPI_LIST_START_LOADER, UPI_LIST_STOP_LOADER, } from "../interface/IUPIList";
class UPIActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getUPIList(data) {
        this.dispatch({ type: UPI_LIST_DATA, payload: { data } });
    }
    loader() {
        this.dispatch({
            type: UPI_LIST_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: UPI_LIST_STOP_LOADER,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: UPI_LIST_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: UPI_LIST_HIDE_ERROR_DATA,
        });
    }
}
export default UPIActions;
